module.exports = new __parcel__URL__("spiritsector.b9939322.png").toString();